import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useSelectedAccountId } from 'hooks/queryParams/useSelectedAccountId';
import { ENTITY } from 'modules/campaigns/config/routes/entity';
import { useReportEntityIds } from 'modules/campaigns/hooks/useReportEntityIds';
import { useReportEntityType } from 'modules/campaigns/hooks/useReportEntityType';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { useSearchApi, FILTERS } from 'services/api';

const useOmniboxQueryParam = queryParamHookFactory(FILTERS.QUERY);
export const useOmniboxQuery = () => {
    const { omniboxSearch } = useSearchApi();
    const [query, setQuery] = useOmniboxQueryParam();
    const [, setReportEntityId] = useReportEntityIds();
    const [, setReportEntityType] = useReportEntityType();
    const [, setAccountId] = useSelectedAccountId();
    const { isLoading, data } = useQuery(['omnibox', query], () => omniboxSearch(query), {
        enabled: !!query,
        retry: false,
    });

    useEffect(() => {
        const hasQueryAndResponse = query && data;
        if (!hasQueryAndResponse) {
            return;
        }
        setQuery();
        if (data.accountId) {
            setAccountId(data.accountId);
        }
        if (data.campaignId) {
            setReportEntityId(data.campaignId);
            setReportEntityType(ENTITY.CAMPAIGN);
        }
    }, [data, query, setAccountId, setReportEntityId, setReportEntityType, setQuery]);

    return isLoading;
};
